// Extracted out of AxiosInstance.js: that module is globally mocked in
// jest.setup.js (as {get, post, put, delete}) for every test in the project,
// so a named export added there would resolve to undefined everywhere.
// This tiny, side-effect-free module (no axios.create() call, nothing to
// mock) is safe for any call site -- including ones that deliberately
// bypass axiosInstance's interceptors -- to import directly.
export function buildAuthHeader() {
  return `Token ${sessionStorage.getItem("Token")}`;
}
